module.exports = __webpack_public_path__ + "img/矩形 814@2x.37170ed3.png";